exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host() {\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 100vh;\n  width: 100vw;\n  overflow-y: auto;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  :host() footer {\n    margin-top: 20px; }\n\nbody {\n  background-color: #FFFFFF; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main